import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { t } from 'utils/translates';

class TypeOperationSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      titleSelectAll: t('Любой тип'),
      value: this.getVerifiedPropStartValue()
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.value !== prevState.value) {
      this.props.handleChangeValue(this.state.value);
    }
  }

  getVerifiedPropStartValue = () => {
    const searchVal = this.props.typeOperations.find(
      i => i.value === this.props.startValue
    );
    if (searchVal) {
      return this.props.startValue;
    }
    return null;
  };

  getSelectValueTitle = () => {
    if (this.state.value === null) {
      return this.state.titleSelectAll;
    }
    return this.props.typeOperations.find(i => i.value === this.state.value)
      .title;
  };

  changeValue = async (event, newValue) => {
    event.preventDefault();
    this.setState({ value: newValue });
  };

  render() {
    return (
      <React.Fragment>
        <button
          type="button"
          className="btn btn-default dropdown-toggle"
          data-toggle="dropdown"
          title={this.state.titleSelectAll}
          aria-expanded="false"
        >
          {this.state.value === 1 ? (
            <i className="fa fa-plus-circle text-success" />
          ) : (
            ''
          )}
          {this.state.value === 2 ? (
            <i className="fa fa-minus-circle text-danger" />
          ) : (
            ''
          )}
          {` ${this.getSelectValueTitle()}`}
        </button>
        <ul className="dropdown-menu" role="menu">
          <li className={this.state.value === null ? 'active' : ''}>
            <a href="" onClick={e => this.changeValue(e, null)}>
              {t('Любой тип')}
            </a>
          </li>
          <li className={this.state.value === '1' ? 'active' : ''}>
            <a href="" onClick={e => this.changeValue(e, '1')}>
              <i className="fa fa-plus-circle text-success" /> {t('Доход')}
            </a>
          </li>
          <li className={this.state.value === '2' ? 'active' : ''}>
            <a href="" onClick={e => this.changeValue(e, '2')}>
              <i className="fa fa-minus-circle text-danger" /> {t('Расход')}
            </a>
          </li>
        </ul>
      </React.Fragment>
    );
  }
}

TypeOperationSelect.defaultProps = {
  startValue: null,
  typeOperations: [
    {
      value: '1',
      title: 'Доход'
    },
    {
      value: '2',
      title: 'Расход'
    }
  ]
};

TypeOperationSelect.propTypes = {
  startValue: PropTypes.string,
  typeOperations: PropTypes.arrayOf(PropTypes.shape),
  handleChangeValue: PropTypes.func.isRequired
};

export default withRouter(TypeOperationSelect);



// WEBPACK FOOTER //
// ./src/components/Common/Inputs/TypeOperationSelect/TypeOperationSelect.js